// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MXgvd","top":"styles_top__2LlTf","left":"styles_left__3V1me","description":"styles_description__1A5FP"};